import React, { useState } from 'react';

import { Maximize4 } from 'iconsax-react';

import classes from './ToolkitPreview.module.scss';

const ToolkitPreview = ({ thumbnail, categoryName }) => {
    const [expanded, setExpanded] = useState(false);

    if (!thumbnail) return null;

    const title = categoryName ? `${categoryName} Preview` : 'Preview';

    return (
        <>
            <div className={classes['card']}>
                <div className={classes['header']}>
                    <h3>{title}</h3>
                    <button
                        type="button"
                        className={classes['expand-btn']}
                        aria-label="Expand preview"
                        onClick={() => setExpanded(true)}
                    >
                        <Maximize4 size={18} />
                    </button>
                </div>
                <div className={classes['preview-area']}>
                    <img
                        src={thumbnail}
                        alt={title}
                        className={classes['preview-image']}
                    />
                </div>
            </div>

            {expanded && (
                <div
                    className={classes['lightbox']}
                    onClick={() => setExpanded(false)}
                    role="dialog"
                    aria-modal="true"
                >
                    <img src={thumbnail} alt={title} />
                </div>
            )}
        </>
    );
};

export default ToolkitPreview;
